var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 18.125-2.229-2.229q-.459.292-1.094.552-.635.26-1.177.385v-1.541q.25-.104.594-.24.344-.135.573-.26L10 12.125v3.896l-4-4H3v-4h2.875L1.875 4l1.063-1.062 14.124 14.124Zm-.125-4.354-1.083-1.083q.333-.605.52-1.282.188-.677.188-1.385 0-1.854-1.115-3.302-1.114-1.448-2.885-1.99V3.188q2.438.479 3.969 2.416Q17 7.542 17 10.021q0 1-.292 1.948-.291.948-.833 1.802Zm-2.583-2.583L11.5 9.396V6.854q.938.417 1.469 1.281.531.865.531 1.886 0 .291-.042.583-.041.292-.166.584ZM10 7.896 8.062 5.958 10 4.021Zm-1.5 4.5v-1.771L7 9.125l-.375.396H4.5v1h2.125Zm-.75-2.521Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.b7a1e031efc0076a95d8dfe15c01d5e4.svg";
export { ForwardRef as ReactComponent };